import { Component, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { SgAriaMessage } from '../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { UsedSzza012aService } from '../../../../sg-kd-shared/services/used-szza012a.service';
import { takeUntil } from 'rxjs/operators';
import { SgKdConstants } from '../../../../sg-kd-shared/sg-kd-constants';
import {
  Sgkd001aRequestHakkomotoInfo,
  Sgkd001aRequestSendtoInfo,
  Sgkd034aResponse
} from 'sg-api';
import { Router } from '@angular/router';
import { UsedSgkd019dSgkd001aService } from '../services/used-sgkd019d-sgkd001a.service';
import { Sgkd019dSendtoInfoComponent } from '../components/sgkd019d-sendto-info/sgkd019d-sendto-info.component';
import { Sgkd019dSendtoSearchComponent } from '../components/sgkd019d-sendto-search/sgkd019d-sendto-search.component';
import { Sgkd019dHakkomotoComponent } from '../components/sgkd019d-hakkomoto/sgkd019d-hakkomoto.component';

@Component({
  selector: 'app-sgkd019d',
  templateUrl: './sgkd019d.component.html',
  styleUrl: './sgkd019d.component.scss'
})
export class Sgkd019dComponent implements OnInit, OnDestroy {

  private onDestroy$ = new Subject();

  @Output() errorMessageModelArray: Array<SgAriaMessage> = [];

  @ViewChild(Sgkd019dSendtoSearchComponent) searchComponent: Sgkd019dSendtoSearchComponent;
  @ViewChild(Sgkd019dSendtoInfoComponent) infoComponent: Sgkd019dSendtoInfoComponent;
  @ViewChild(Sgkd019dHakkomotoComponent) hakkomotoComponent: Sgkd019dHakkomotoComponent;

  /** メインフォーム */
  mainForm: UntypedFormGroup;
  /** 業務日付 */
  businessDate: string;
  /** 住所情報・お客さま氏名取得APIレスポンス */
  response: Sgkd034aResponse;

  constructor(
    private usedSgkd019dSgkd001aService: UsedSgkd019dSgkd001aService,
    private usedSzza012aService: UsedSzza012aService,
    private formBuilder: UntypedFormBuilder,
    private router: Router) {
  }

  /**
   * 初期処理
   * 
   * @memberof Sgkd019dComponent
   */
  ngOnInit(): void {

    // 業務日付取得
    this.usedSzza012aService.doSzza012a()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
        this.businessDate = response.todayDay;
      }, error => {
      });

    // メインフォームの生成
    this.mainForm = this.createMainForm();
  }

  /**
   * 破棄処理
   * 
   * @memberof Sgkd019dComponent
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  /**
   * 印刷ボタン押下処理
   * 
   * @memberof Sgkd019dComponent
   */
  onClickPrint(): void {

    // メッセージのクリア
    this.clearMessage();
    // 送付先情報
    let sendto: Sgkd001aRequestSendtoInfo = {
      /** 郵便番号 */
      postno: this.infoComponent.infoForm.get('postNo').value,
      /** 番地・号 */
      buildingnumber: this.infoComponent.infoForm.get('buildingnumber').value,
      /** 住宅・号棟漢字名 */
      visitSupadrAname: this.infoComponent.infoForm.get('visitSupadrAname').value,
      /** 屋号・業種漢字名 */
      visitYagouAname: this.infoComponent.infoForm.get('visitYagouAname').value,
      /** 送付先宛名 */
      sendtoAddressee: this.infoComponent.infoForm.get('sendtoAddress').value
    };

    /** 支払契約番号 */
    if (this.infoComponent.infoForm.get('cbInput')?.value === false &&
        this.searchComponent.searchForm.get('searchKeyClaimCtrNo').value !== '') {
      // 手入力でないかつ検索請求契約番号が空でない場合、請求契約番号検索時に退避させた請求契約番号を設定
      sendto.payCtrNo = this.searchComponent.searchForm.get('searchKeyClaimCtrNo').value;
    }

    // 手入力かつ郵便番号検索の場合
    if (this.infoComponent.infoForm.get('cbInput')?.value && this.infoComponent.isPostnoSearch()) {
      /** 都道府県 */
      sendto.pfc = this.infoComponent.infoForm.get('pfcAnameInput').value;
      /** 行政市区 */
      sendto.administrativecityward = this.infoComponent.infoForm.get('admncwnmInput').value;
      /** 行政町名 */
      sendto.administrativetownname = this.infoComponent.infoForm.get('admntnmInput').value;
      /** 丁目 */
      sendto.chome = this.infoComponent.infoForm.get('chomeInput').value;
    } else {
      /** 都道府県 */
      sendto.pfc = this.infoComponent.infoForm.get('pfcAname').value;
      /** 行政市区 */
      sendto.administrativecityward = this.infoComponent.infoForm.get('admncwnm').value;
      /** 行政町名 */
      sendto.administrativetownname = this.infoComponent.infoForm.get('admntnm').value;
      /** 丁目 */
      sendto.chome = this.infoComponent.infoForm.get('chome').value;
    }

    // 発行元
    let hakkomoto: Sgkd001aRequestHakkomotoInfo = {
      /** 問い合わせ先郵便番号 */
      contactPostno: this.hakkomotoComponent.hakkomotoForm.get('hakkomotoPostno').value,
      /** 問い合わせ先住所 */
      contactAddr: this.hakkomotoComponent.hakkomotoForm.get('hakkomotoAddr').value,
      /** 問い合わせ先窓口 */
      contactMadoguchi: this.hakkomotoComponent.hakkomotoForm.get('contactMadoguchi').value,
      /** 問い合わせ先電話番号 */
      contactTelno: this.hakkomotoComponent.hakkomotoForm.get('hakkomotoTelno').value
    };

    // 宛名印刷
    this.usedSgkd019dSgkd001aService.print(sendto, hakkomoto)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
        response.responseCommon.errors.forEach(
          (message) => this.pushSgAriaMessage(message.message)
        );
        window.scrollTo(0, 0);
      }, error => {
      }
    );
  }

  /**
   * 戻るボタン押下処理
   * 
   * @memberof Sgkd019dComponent
   */
  goToPrevious(): void {
    this.router.navigate([SgKdConstants.PATH.MANAGE_MENU]);
  }

  /**
   * 印刷ボタン活性判定
   * 
   * @return boolean ボタン活性判定結果
   * @memberof Sgkd019dComponent
   */
  isDisabledBtnPrint(): boolean {
    // チェックボックスが未選択
    if (this.infoComponent?.infoForm?.get('cbClmto')?.value === false &&
        this.infoComponent?.infoForm?.get('cbCtrper')?.value === false &&
        this.infoComponent?.infoForm?.get('cbSupplydestination')?.value === false &&
        this.infoComponent?.infoForm?.get('cbInput')?.value === false) {
      return true;
    }
    // 手入力で必須項目の入力がない
    if (this.infoComponent?.infoForm?.get('cbInput')?.value === true) {
      if (this.infoComponent?.isPostnoSearch() === false) {
        if (!this.infoComponent?.infoForm?.get('postNo')?.valid ||
            !this.infoComponent?.infoForm?.get('pfcAname')?.valid ||
            !this.infoComponent?.infoForm?.get('admncwnm')?.valid ||
            !this.infoComponent?.infoForm?.get('admntnm')?.valid) {
          return true;
        }
      } else {
        if (!this.infoComponent?.infoForm?.get('postNo')?.valid ||
            !this.infoComponent?.infoForm?.get('pfcAnameInput')?.valid ||
            !this.infoComponent?.infoForm?.get('admncwnmInput')?.valid ||
            !this.infoComponent?.infoForm?.get('admntnmInput')?.valid) {
          return true;
        }
      }
      if (!this.infoComponent?.infoForm?.get('sendtoAddress')?.valid) {
        return true;
      }
    }
    // 発行元にエラーがある
    if (!this.hakkomotoComponent?.hakkomotoForm?.get('hakkomotoPostno')?.valid ||
        !this.hakkomotoComponent?.hakkomotoForm?.get('hakkomotoAddr')?.valid ||
        !this.hakkomotoComponent?.hakkomotoForm?.get('contactMadoguchi')?.valid ||
        !this.hakkomotoComponent?.hakkomotoForm?.get('hakkomotoTelno')?.valid) {
      return true;
    }
    return false;
  }

  /**
   * メッセージ領域のクリア
   * 
   * @memberof Sgkd019dComponent
   */
  clearMessage(): void {
    this.errorMessageModelArray = [];
  }

  /**
   * 住所情報・お客さま氏名取得APIレスポンス設定処理
   * 
   * @param response 住所情報・お客さま氏名取得APIレスポンス
   * @memberof Sgkd019dComponent
   */
  setResponse(response: Sgkd034aResponse) {
    this.response = response;
    this.infoComponent.setResponse(response);
  }

  /**
   * メインFormの生成
   * 
   * @returns - メインForm
   * @memberof Sgkd019dComponent
   */
  private createMainForm(): UntypedFormGroup {
    return this.formBuilder.group({});
  }

  /**
   * インフォメッセージのメッセージエリアモデル作成
   * 
   * @param info インフォメッセージ
   * @memberof Sgkd019dComponent
   */
  pushSgAriaMessage(message: string): void {
    this.errorMessageModelArray.push({
      message: message,
      messageClass: SgKdConstants.MESSAGE.INFO.MESSAGE_CLS,
      icon: SgKdConstants.MESSAGE.INFO.ICON,
      iconClass: SgKdConstants.MESSAGE.INFO.ICON_CLS,
    });
  }
}

